import axios from "axios";
import { BASE_URL } from "../common.ts";

// ---------------- GET APIs  ----------------
export async function getActive() {
  const requestUrl = `${BASE_URL}/`;
  try {
    await axios.get(requestUrl);
    return true;
  } catch (err) {
    console.error(err);
  }
}
export async function getUser(accessToken, email) {
  const requestUrl = `${BASE_URL}/get-user/${email}`;
  try {
    let response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
}
export async function getHome() {
  try {
    const response = await fetch("/content/home.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}
export async function getSkuList() {
  try {
    const res = await fetch("/content/sku/index.json");
    return res.json();
  } catch (err) {
    console.error(err);
  }
}

export async function getFooter() {
  try {
    const response = await fetch("/content/footer.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getTrips() {
  try {
    const response = await fetch("/content/trips.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}
export async function getScuba() {
  try {
    const response = await fetch("/content/scuba.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getSky() {
  try {
    const response = await fetch("/content/skydive.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getAbout() {
  try {
    const response = await fetch("/content/about.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getMyDetails(accessToken) {
  const requestUrl = `${BASE_URL}/my/details`;
  try {
    const response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
}

export async function getDetail(sku) {
  const requestUrl = `/content/sku/${sku}.json`;
  try {
    const response = await fetch(requestUrl);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getPrivacyPolicy() {
  try {
    const response = await fetch("/content/privacy-policy.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getNavbarDetails() {
  try {
    const response = await fetch("/content/navbar.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getRefundPolicy() {
  try {
    const response = await fetch("/content/refund-policy.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

export async function getTerms() {
  try {
    const response = await fetch("/content/terms.json");
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

// ---------------- POST APIs  ----------------

export async function postQuote(body, accessToken) {
  const requestUrl = `${BASE_URL}/enquiries/request?type=quote`;
  try {
    const response = await axios.post(requestUrl, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export const loginWithGoogle = async (idToken) => {
  try {
    const requestUrl = `${BASE_URL}/auth/google-login`;
    const response = await axios.post(
      requestUrl,
      {},
      {
        headers: {
          Authorization: `G-Bearer ${idToken}`,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Google login API error:", err);
    throw err;
  }
};

export const updatePhoneNumber = async ({ phoneNo, accessToken }) => {
  try {
    const requestUrl = `${BASE_URL}/auth/update-phone`;
    const response = await axios.post(
      requestUrl,
      { phoneNo },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// ---------------- WhatsApp OTP authentication ----------------
// Point REACT_APP_WA_AUTH_URL at the WA-USERAUTH/Berry service origin.
// Example: http://localhost:3000 (do not include /api/v1/auth).
const WA_AUTH_BASE_URL = (
  process.env.REACT_APP_WA_AUTH_URL || BASE_URL
).replace(/\/$/, "");
const WA_AUTH_API = `${WA_AUTH_BASE_URL}/api/v1/auth`;

export const getWhatsAppCaptcha = async () => {
  const response = await axios.get(`${WA_AUTH_API}/captcha/new`);
  return response.data;
};

export const sendWhatsAppOtp = async ({
  mobile,
  captchaId,
  captchaCode,
  name,
  email,
  isResend = false,
  appKey,
}) => {
  const response = await axios.post(`${WA_AUTH_API}/otp/send`, {
    mobile,
    captchaId,
    captchaCode,
    name,
    email,
    isResend,
    appKey,
  });
  return response.data;
};

export const verifyWhatsAppOtp = async ({ mobile, otp, appKey, email }) => {
  const response = await axios.post(`${WA_AUTH_API}/otp/verify`, {
    mobile,
    otp,
    appKey,
    email,
  });

  return response.data;
};

// ---------------- admin APIs ----------------

export const createAdminEnquiry = async (enquiryData, accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/admin/enquiries/create`;

    const response = await axios.post(requestUrl, enquiryData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (err) {
    console.error("Create admin enquiry error:", err);

    throw (
      err.response?.data || {
        error: "Failed to create enquiry. Please try again.",
      }
    );
  }
};

/* ---------- ADMIN: SEARCH USERS FOR ENQUIRY LINKING ---------- */
export const searchAdminUsers = async (query, accessToken) => {
  try {
    const response = await axios.get(`${BASE_URL}/admin/users/search`, {
      params: { q: query },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (err) {
    console.error("Search admin users error:", err);

    throw (
      err.response?.data || {
        error: "Failed to search registered users.",
      }
    );
  }
};

/* ---------- ADMIN: LINK ENQUIRY TO USER ---------- */
export const linkAdminEnquiry = async (enquiryId, userEmail, accessToken) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/enquiries/${encodeURIComponent(enquiryId)}/link`,
      { userEmail },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.error("Link admin enquiry error:", err);

    throw (
      err.response?.data || {
        error: "Failed to link enquiry to user.",
      }
    );
  }
};

export const getallENQ = async (queryString = "", accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/all/enquiries${queryString}`;
    const response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("getallENQ error:", err);
    if (err.response?.data) {
      throw err.response.data;
    }
  }
};

export const getallENQAdmin = async (queryString = "", accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/all/enquiries/admin${queryString}`;
    const response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const updateEnquiry = async (enqId, updates, accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/enquiries/update/${enqId}`;
    const res = await axios.post(requestUrl, updates, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res.data;
  } catch (err) {
    console.error(err);
  }
};
// --- SAVE ITINERARY ---
export const saveItinerary = async (itineraryId, data, accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/itinerary/save/${itineraryId}`;
    const response = await axios.post(requestUrl, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("API Save Error:", err);
    throw err;
  }
};

// --- GET ITINERARY ---
export const getItinerary = async (itineraryId, accessToken) => {
  try {
    const requestUrl = `${BASE_URL}/itinerary/get/${itineraryId}`;
    const response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("API Get Error:", err);
    throw err;
  }
};
